import React, { Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import parse from 'html-react-parser';
import GenericHeader from '@common-components/pageHeader/GenericHeader';
import Text from '@components/common/form/Text';

interface IPreOEPLandingProps {
    exchangeName: string;
    phone: string;
}

const PreOEPLanding = ({ exchangeName, phone }:IPreOEPLandingProps) => {
    const intl = useIntl();

    return (
        <Fragment>
            <div className="grid-row gi-panel">
                <GenericHeader
                    id="welcome"
                    text="pre-oep_landing.header"
                    tag="h1"
                    headerClassName={['mobile:grid-col-12 tablet:grid-col-fill']}
                    textReplacements={{
                        exchangeName
                    }}
                />
                <p>{ parse(intl.formatMessage({ id: 'pre-oep_landing.para1' }, { exchangeName })) }</p>
                <p>{ parse(intl.formatMessage({ id: 'pre-oep_landing.para2' })) }</p>
                <Text
                    id='pre-oep_landing.para3'
                    text='pre-oep_landing.para3'
                    display='block'
                    linkText='pre-oep_landing.para3.text_link'
                    isReplacementALink={true}
                    textReplacements={{
                        exchangeName,
                        phone,
                        br: <br/>
                    }}
                    path={intl.formatMessage({ id: 'pre-oep_landing.para3.full_link' })}
                />
                <Text
                    id='pre-oep_landing.para4'
                    text='pre-oep_landing.para4'
                    display='block'
                    linkText='pre-oep_landing.para4.text_link'
                    isReplacementALink={true}
                    textReplacements={{
                        exchangeName,
                        phone,
                        br: <br/>
                    }}
                    path={intl.formatMessage({ id: 'pre-oep_landing.para4.full_link' })}
                />
            </div>
        </Fragment>
    );
};

export default PreOEPLanding;